import React from "react";

export const Musics = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={200}
            height={156}
            viewBox="0 0 200 156"
            fill="none"
            {...props}
        >
            <path
                d="M87.645 7.802l-1.45-.388-.387 1.449L74.16 52.329l-.389 1.45 1.45.387 48.296 12.941 1.449.389.388-1.45 11.647-43.466.388-1.449-1.449-.388L87.645 7.802z"
                fill="#299BEF"
                stroke="#157BF2"
                strokeWidth={3}
            />
            <path
                d="M107.816 47.889l-.144-4.261-6.033-1.617-2.256 3.618-3.78-1.013 10.293-15.052 4.29 1.15 1.411 18.188-3.781-1.014zm-.193-7.429l-.169-4.17c-.006-.277-.02-.632-.041-1.066-.012-.44-.026-.885-.043-1.334a30.8 30.8 0 01-.001-1.177c-.158.289-.367.645-.626 1.07a106.118 106.118 0 01-1.213 1.992l-2.22 3.53 4.313 1.155z"
                fill="#fff"
            />
            <path
                transform="rotate(15 92.819 17.47)"
                stroke="#fff"
                d="M92.8186 17.4704H128.8186V49.4704H92.8186z"
            />
            <circle cx={50} cy={103} r={40} fill="#157BF2" />
            <circle cx={50} cy={103} r={15} fill="#fff" />
            <circle
                cx={4}
                cy={4}
                r={4}
                transform="matrix(1 0 0 -1 46 107)"
                fill="#32393E"
            />
            <path
                d="M69.619 77.382c2.653 1.754 3.893 3.01 5.657 5.657l-5.657 5.656c-1.41-2.43-2.559-3.694-5.657-5.656l5.657-5.657zM29.343 126.814c-2.653-1.755-3.893-3.011-5.657-5.657l5.657-5.657c1.41 2.431 2.559 3.695 5.657 5.657l-5.657 5.657z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M73.724 143h108.5v-6H149.37l-13.403-43.362A8 8 0 00128.324 88H68.79c-5.303 0-9.138 5.066-7.7 10.17L73.725 143z"
                fill="#32393E"
            />
            <circle cx={146.505} cy={113.579} r={14} fill="#FE9235" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M147.505 106.579h-2v6h-6v2h6v6h2v-6h6v-2h-6v-6z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M129.428 34.181a4.001 4.001 0 00-2.941 4.3l1.255 11.419.007-.002 1.457 15.7a9.238 9.238 0 00-2.763.315c-3.934 1.054-6.46 4.383-5.642 7.436.818 3.052 4.67 4.673 8.604 3.619 3.933-1.054 6.459-4.383 5.641-7.436a4.631 4.631 0 00-.131-.409l-1.984-20.614 22.075-5.914 2.511 15.365a9.27 9.27 0 00-2.586.32c-3.933 1.053-6.459 4.383-5.641 7.435.818 3.053 4.67 4.673 8.603 3.62 3.795-1.018 6.28-4.152 5.715-7.113l.012-.004-4.206-25.732-1.539-9.927-28.447 7.622z"
                fill="#FE9235"
            />
        </svg>
    )
}
